import React from "react";
import { Film } from "lucide-react";

export const mediaSrc = (item) => item.media_url || (item.media_urls || [])[0];

const PLACEHOLDER = {
  waiting_for_video: "Concept - waiting for your approval",
  production_approved: "Approved - waiting for VPS production",
  producing: "Video in production",
  production_failed: "Production failed",
};

export const ItemMedia = ({ item, large = false, onOpen }) => {
  const src = mediaSrc(item);
  const box = large ? "max-h-[75vh] w-auto mx-auto" : "w-full h-[260px]";
  if (PLACEHOLDER[item.status] && (!src || item.media_type !== "video")) {
    return (
      <div className={`${large ? "h-[50vh]" : "h-[260px]"} grid place-items-center bg-black/40 text-[color:var(--muted)]`} data-testid={`gallery-video-pending-${item.id}`}>
        <div className="flex flex-col items-center gap-2 text-xs font-mono uppercase tracking-[0.1em] text-center px-4">
          <Film className={`h-6 w-6 ${item.status === "producing" ? "animate-pulse" : ""}`} /> {PLACEHOLDER[item.status]}
        </div>
      </div>
    );
  }
  if (!src) return <div className={`${large ? "h-[50vh]" : "h-[260px]"} grid place-items-center text-xs text-[color:var(--muted)]`}>No media</div>;
  if (item.media_type === "video") {
    return (
      <video
        src={item.poster_url ? src : `${src}#t=0.1`}
        poster={item.poster_url || undefined}
        controls
        muted
        playsInline
        preload="metadata"
        className={`${box} object-contain bg-black`}
        data-testid={`${large ? "detail" : "gallery"}-video-${item.id}`}
      />
    );
  }
  return (
    <img
      src={src}
      alt={item.caption || item.id}
      onClick={onOpen}
      className={`${box} ${large ? "object-contain" : "object-cover cursor-zoom-in"} bg-black`}
      data-testid={`${large ? "detail" : "gallery"}-image-${item.id}`}
    />
  );
};
